import type { DialogProps } from '@mui/material/Dialog';

export type ConfirmDialogProps = Omit<DialogProps, 'title' | 'content'> & {
  onClose: () => void;
  title: string | React.ReactNode;
  action?: React.ReactNode;
  content?: string | React.ReactNode;
  type?: ConfirmDialogType;
  // Renders full width below the icon/title/content row, instead of being
  // indented into the narrow column next to the icon.
  belowContent?: React.ReactNode;
};

export enum ConfirmDialogType {
  Warning = 'warning',
  Error = 'error',
  Info = 'info',
  Success = 'success',
}
